<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.customer.remove_customer_confirm_header' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <div class="row">
        <div class="col-lg-12">
            <div class="customer-message">{{'bikeshop.workshop.jobcard.customer.remove_customer_confirm_message' |
                translate : {customerDetails : customer.Name ? (customer.Name + " " + customer.Surname) : customer.Email ? customer.Email : customer.PhoneNumber ? customer.PhoneNumber : customer.ID } }}</div>
        </div>
    </div>
    
</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'general.cancel' | translate"
            [style]="'outline'" [disabled]="deleting" [loading]="deleting" (buttonClick)="cancel()"
            [size]="'xl'"></hub-button>
        <hub-button [text]="'bikeshop.general.delete' | translate"
            [style]="'secondary'" [disabled]="deleting" [loading]="deleting" (buttonClick)="deleteCustomer()"
            [size]="'xl'"></hub-button>
    </div>
</div>